import { useCalendar } from '$features/calendar/hooks/use-calendar'
import { Slot } from '$features/calendar/hooks/use-calendar-slots'
import { cn } from '$components'
import { memo } from 'react'

export type CalendarSlotProps = {
  data: Slot
}

export const CalendarSlot = memo(({ data }: CalendarSlotProps) => {
  const { navigate, viewType } = useCalendar()

  const onClick = () => {
    navigate(`${viewType}/create`, {
      state: {
        slot: {
          id: data.id,
          start: data.start.toISOString(),
          finish: data.finish.toISOString(),
          groomerId: data.groomerId,
        },
      },
    })
  }

  return (
    <button
      onClick={onClick}
      aria-label="Create new appointment"
      className={cn('w-full h-full', {
        'bg-[repeating-linear-gradient(45deg,transparent,transparent_4px,#f9fafb_4px,#f9fafb_8px)]': !data.isAvailable,
      })}
    />
  )
})

CalendarSlot.displayName = 'CalendarSlot'
